let language = {
    "300335": "Opps,store products are being synchronized, please refresh the page later to see the synchronization result.",
    "300327": "Opps, error happen when synchronizing this product to your e-shop. The current store cannot link to woocommerce, please check the status of your woocommerce link.",
    "2200714": "Opps, error happen when synchronizing this product to your e-shop.",
    "300317": "Opps, Current Store The store to which the product belongs does not exist.",
    "300353": "Opps, The system is busy, please try again later.",
    "300351": "Opps, The current store product is synchronizing, please try again later.",
    "302104": "Opps, shopify currently only supports [SKU WITH DESIGN] store products.",
    "302105": "Opps, shopify Store products currently only support fixed pricing configuration.",
    "300350": "Opps, The current store is closed, the product synchronization task cannot be performed.",
    /*********************** Mockup Rest Code ********************** */
    "50000002": "Unsupported parameter type,only support use productInstance or product to creat product mockup",
    "50000010": "Mockup configuration error:Wrong assembly mockup parameter",
    "50000011": "Mockup configuration error:Color placeholder calculation error for mockup template",
    "50000012": "Mockup configuration error:Mask placeholder calculation error for mockup template",
    "50000013": "Mockup configuration error:Image placeholder calculation error for mockup template",
    "50000020": "Failed to render mockup"
};

export { language }